import React, { useState, useEffect, useContext, useRef } from 'react'
import {
  Layout,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  message,
  Form,
  Select,
  Tooltip,
  Checkbox,
  Spin,
  Alert,
  DatePicker,
  AutoComplete,
  Space,
  Breadcrumb,
  InputNumber
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { injectIntl } from 'react-intl'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { STOCK_LIST } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  notAllowMsgCheck,
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  formatDigits,
  loadSearchSelectedProduct,
  StringIsNullOrEmpty,
  verifyPkgFeature
} from '../../../appRedux/actions'
import moment from 'moment'
import { PurchaseOrderType } from '../../../constants/PurchaseOrderType'
import { StockOrderTypesEnum } from '../../../constants/StockOrderTypesEnum'
import ProductSearch from '../../../components/ProductSearch'
import { wrap } from 'module'
import GeneralProductImport from '../../../components/GeneralProductImport'
import { text } from '@fortawesome/fontawesome-svg-core'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'
import { ArrowLeftOutlined } from '@ant-design/icons'

const ReturnStock = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const EditableContext = React.createContext()

  //#region UseSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )
  const getReduxGeneralImportProducts = useSelector(
    ({ Products }) => Products.generalImportProducts
  )
  //#endregion UseSelector

  //#region useState
  const [options, setOptions] = useState([])
  const [selected, setselected] = useState([])
  const [orderCount, setorderCount] = useState(0)
  const [selectedSOutlet, setselectedSOutlet] = useState('')
  const [deliverTo, setdeliverTo] = useState('')
  const [isShowProduct, setIsShowProduct] = useState(false)
  const [getIsLoading, setIsLoading] = useState(true)
  const [form] = Form.useForm()
  const [initialFormValue, setinitialFormValue] = useState()
  const [grandTotal, setgrandTotal] = useState(0)
  const [getSearchProd, setSearchProd] = useState([])
  const [supplierData, setSupplierData] = useState([])
  const [outletData, setOutletData] = useState([])
  const [updateTable, setUpdateTable] = useState(false)
  const [getCurrSymbol, setCurrSymbol] = useState('')

  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [isRegistering, SetisRegistering] = React.useState(true)
  const [getCurrData, setCurrData] = useState({})
  const [getShortCurr, setShortCurr] = useState('')
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  //#endregion useState

  //#region UseEffect
  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])
  React.useEffect(() => {
    let mounted = true
    if (mounted && selected.length > 0) {
      let total = 0
      selected.forEach(data => {
        total += parseFloat(data.totalCost)
      })
      setgrandTotal(parseFloat(total))
    }

    return () => (mounted = false)
  }, [selected])
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(STOCK_LIST))
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      getSuppliersService()
      getOutletsService()
      form.setFieldsValue({
        NameRef: `Return - ${moment().format('ddd DD MMM YYYY ')}`
      })
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct)
      }
    }
    return () => (mounted = false)
  }, [getSearchSelectedProduct])

  React.useEffect(() => {
    let mounted = true
    let newProd = []
    if (mounted) {
      if (
        getReduxGeneralImportProducts &&
        getReduxGeneralImportProducts != null &&
        getReduxGeneralImportProducts.length > 0
      ) {
        let selectedOut = form.getFieldValue('ReturnFrom')
          ? parseInt(form.getFieldValue('ReturnFrom'))
          : 0
        let counter = selected && selected.length ? selected.length + 1 : 1
        newProd = getReduxGeneralImportProducts.map((e, seq) => {
          return {
            orderNo: counter++,
            key: e.productID,
            productName: e.productName,
            quantity: e.quantity,
            supplyPrice: e.supplyPrice
              ? parseFloat(e.supplyPrice)
              : parseFloat('0.00'),
            totalCost: parseFloat(e.quantity * e.supplyPrice).toFixed(
              getDefaultDecimalPlaces
            ),
            stockInHand:
              e.inventoryCount &&
              e.inventoryCount.length > 0 &&
              e.inventoryCount.filter(a => a.outletID == selectedOut).length > 0
                ? e.inventoryCount.filter(a => a.outletID == selectedOut)[0]
                    .inventory
                : 0,
            isProductInventory: e.isProductInventory
          }
        })

        if (newProd.length > 0) {
          if (
            selected.length > 0 &&
            !selected.some(e => e.key === newProd.key)
          ) {
            setselected(selected.concat(newProd))
          } else if (selected.length == 0) setselected(newProd)
        }
      }
    }
    return () => (mounted = false)
  }, [getReduxGeneralImportProducts])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  //#endregion UseEffect

  //#region API Services

  async function getSuppliersService () {
    await ds
      .getSuppliers({ IsAll: true }, BEHAVIOUR_TYPE.GET)
      .then(res => {
        setIsLoading(false)
        if (res.data.data && res.data.data.length > 0) {
          let data = res.data.data.map(e => {
            return {
              id: e.supplierID,
              label: e.supplierName
            }
          })
          setSupplierData(data)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setIsLoading(false)
      })
  }
  async function getOutletsService () {
    const getOutlets = ds.getStoreOutlets()
    await getOutlets
      .then(response => {
        setIsLoading(false)
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data && response.data.data.length > 0) {
              let data = response.data.data
              let outletssData = data.map(e => {
                return {
                  id: e.sOutletId,
                  outlet: e.outletName
                }
              })
              setOutletData(outletssData)
            }
          }
        }
      })
      .catch(e => {
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut("store.getState()"));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }
  async function postStockOrderService (body, behaviorType, featureID) {
    await ds
      .postStockOrder(body, behaviorType, featureID)
      .then(res => {
        SetisRegistering(false)
        if (res.data.data) {
          message.success('Successfully Saved')
          history.push('/Dashboard/inventory/stockcontrol/stockcontrollist')
        } else if (res.data.data != null) {
          SetisRegistering(false)
          message.success('Data not saved, try again or Reload page')
        }
      })
      .catch(error => {
        SetisRegistering(false)
        message.error('Something went wrong...')
      })
  }

  //#endregion API Services

  //#region Custom Functions
  function removeTableProd (e) {
    let data = selected.filter(a => a.key != e.key)
    setselected(data)
    if (data.length == 0) {
      setgrandTotal(0)
    }
  }

  function onOutletChange (w) {
    if (selected && selected.length > 0) {
      selected.map(r => {
        let prod =
          getSearchProd && getSearchProd.length > 0
            ? getSearchProd.filter(
                t =>
                  t.productID.substring(0, t.productID.indexOf('&')) ==
                  r.key.substring(0, r.key.indexOf('&'))
              )
            : []
        if (prod.length > 0) {
          let e = prod[0]
          r.stockInHand =
            e.inventoryCount &&
            e.inventoryCount.length > 0 &&
            e.inventoryCount.filter(
              a => a.outletID == parseInt(getDecryptID(w))
            ).length > 0
              ? e.inventoryCount.filter(
                  a => a.outletID == parseInt(getDecryptID(w))
                )[0].inventory
              : 0
          setUpdateTable(!updateTable) //to update table data
        }
      })
    }
    handleReturnFromChange(w)
  }
  const validateReturnNumber = (rule, value, callback) => {
    let body = {
      OrderNumber: value,
      PurchaseOrderType: PurchaseOrderType.SupplierReturnNumber
    }
    const getIsExist = ds.checkIsOrderNumberExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          callback('This order number already exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }

  const onSelect = async selectedObj => {
    let selectedOut = form.getFieldValue('ReturnFrom')
      ? parseInt(form.getFieldValue('ReturnFrom'))
      : 0
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID
      }
    } else {
      productID = ''
    }
    if (!StringIsNullOrEmpty(productID)) {
      await ds
        .getBookSearchProd(
          `?keys=""&outletid=${''}&isstock=${true}&isInventory=${false}&isActiveProduct=${false}&isPB=${false}&isVariantProduct=${true}&productID=${productID}`
        )
        .then(response => {
          const productData = response.data
          if (productData.msgCode == 'GENERAL_SUCCESS') {
            if (productData && productData.data.length > 0) {
              newProd = productData.data.map((e, seq) => {
                return {
                  orderNo: selected.length + 1,
                  key: e.productID,
                  productName: e.productName,
                  quantity: e.quantity,
                  supplyPrice: e.supplyPrice
                    ? parseFloat(e.supplyPrice)
                    : parseFloat('0.00'),
                  totalCost: parseFloat(e.quantity * e.supplyPrice).toFixed(2),
                  stockInHand:
                    e.inventoryCount &&
                    e.inventoryCount.length > 0 &&
                    e.inventoryCount.filter(a => a.outletID == selectedOut)
                      .length > 0
                      ? e.inventoryCount.filter(
                          a => a.outletID == selectedOut
                        )[0].inventory
                      : 0,
                  isProductInventory: e.isProductInventory
                }
              })
            }
          }
          if (productData.msgCode == 'GENERAL_ERROR') {
            message.error(productData.msgDescription)
          }
        })
        .catch(e => console.log('Product Search Issue', e))

      if (newProd.length > 0) {
        if (selected.length > 0 && !selected.some(e => e.key === productID)) {
          setselected(selected.concat(newProd))
        } else if (selected.length == 0) setselected(newProd)
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
      }
    }
  }

  const handleQuantityChange = ({ target: { value } }, index, record) => {
    setselected(prevData => {
      const newData = [...prevData]
      const newItem = { ...newData[index] }
      newItem.quantity = value
      newItem.totalCost = parseFloat(
        parseFloat(record.supplyPrice) * parseInt(value)
      ).toFixed(2)
      newData[index] = newItem
      return newData
    })
  }

  const handleFocus = event => event.target.select()

  function validateInputNumber (rule, value) {
    if (value <= 0) {
      return Promise.reject('Please enter a number greater than zero')
    }
    return Promise.resolve()
  }

  //#endregion Custom Functions End

  const formFields = () => {
    const children = []
    children.push(
      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`ReturnNumber`}
          label={<IntlMessages id='stock.edit.return' />}
          rules={[
            {
              required: true,
              message: <IntlMessages id='products.promoadd.disperalert' />
            },
            {
              validator: validateReturnNumber
            }
          ]}
        >
          <Input size='large' />
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`DeliverTo`}
          label={<IntlMessages id='stock.add.delto' />}
          rules={[
            {
              required: true,
              message: <IntlMessages id='products.promoadd.disperalert' />
            }
          ]}
        >
          <Select
            size='large'
            placeholder={'Select Supplier'}
            showSearch
            optionFilterProp='children'
          >
            {supplierData &&
              supplierData.length > 0 &&
              supplierData.map((e, key) => {
                return (
                  <Select.Option key={key} value={e.id}>
                    {e.label}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`ReturnFrom`}
          label={<IntlMessages id='stock.retstock.retfrom' />}
          rules={[
            {
              required: true,
              message: <IntlMessages id='products.promoadd.disperalert' />
            }
          ]}
        >
          <Select
            size='large'
            width='100%'
            placeholder={'Select Outlet'}
            onChange={w => {
              onOutletChange(w)
            }}
            showSearch
            optionFilterProp='children'
          >
            {outletData &&
              outletData.length > 0 &&
              outletData.map((data, i) => {
                return (
                  <Select.Option key={i} value={data.id}>
                    {data.outlet}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`DeliveryDue`}
          label={<IntlMessages id='stock.edit.deliverdue' />}
        >
          <DatePicker
            size='large'
            className='gx-mb-3 gx-w-100'
            inputReadOnly={true}
          />
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`NameRef`}
          label={<IntlMessages id='stock.edit.nameref' />}
          rules={[
            {
              required: true,
              message: <IntlMessages id='products.promoadd.disperalert' />
            }
          ]}
        >
          <Input size='large' placeholder='Name/ Refernce' />
        </Form.Item>
      </Col>,

      <Col lg={8} md={8} sm={12} xs={24} style={{ display: 'block' }}>
        <Form.Item
          className='ant-form-item-label-custom'
          name={`SupplierInvoiceNumber`}
          label={<IntlMessages id='stock.edit.suppinvo' />}
        >
          <Input size='large' placeholder='Supplier Invoice' />
        </Form.Item>
      </Col>
    )

    return children
  }
  var columns = [
    {
      title: 'Order',
      dataIndex: 'orderNo',
      key: 'orderNo'
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName'
    },
    {
      title: `Stock In Hand${updateTable ? '' : ''}`,
      dataIndex: 'stockInHand',
      key: 'stockInHand',
      editable: false,
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      },
      render: (text, record) => {
        let count = text
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      editable: true,
      render: (text, record, index) => {
        function putQuantity () {
          let keyName = `returnquantity${record.key}`
          form.setFieldsValue({
            [keyName]: record.quantity ? parseFloat(record.quantity) : 0
          })
        }
        putQuantity()
        return (
          <Form
            form={form}
            name='ReturnStockForm'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              style={{ margin: 0 }}
              name={`returnquantity${record.key}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter a number'
                },
                {
                  validator: validateInputNumber
                }
              ]}
            >
              <InputNumber
                type='number'
                width={'50'}
                value={text}
                min={1}
                onPressEnter={v => handleQuantityChange(v, index, record)}
                onBlur={v => handleQuantityChange(v, index, record)}
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.quantity !== prevRecord.quantity
      }
    },
    {
      title: 'Supply Price',
      dataIndex: 'supplyPrice',
      key: 'supplyPrice',
      editable: true,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : '0.00'
        return (
          <Tooltip
            title={
              <span style={{ color: 'black' }}>
                <IntlMessages id='sell.sell.retrievesell.clicktordfit' />
              </span>
            }
            color={'#d5d6d7'}
          >
            <strong>
              {final}
              {getCurrSymbol}
            </strong>
          </Tooltip>
        )
      }
    },
    {
      title: 'Total',
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text, record) => {
        let totalCost = parseFloat(
          record.quantity * record.supplyPrice
        ).toFixed(2)
        if (selected.length == 1) {
          setgrandTotal(totalCost)
        }
        return (
          <span>
            <strong>
              {getCurrSymbol}
              {text ? formatDigits(text, getDefaultDecimalPlaces) : '0.00'}
            </strong>
          </span>
        )
      }
    },
    {
      title: '',
      dataIndex: 'remove',
      key: 'remove',
      render: (text, record) => (
        <a
          className='trash-icon-btn'
          onClick={() => removeTableProd(record)}
          style={{ marginLeft: 22, fontSize: 'large' }}
        >
          <i className='icon icon-trash' />
        </a>
      )
    }
  ]

  const onFinish = values => {
    try {
      setIsLoading(true)
      let returnProduct = {}
      if (!isShowProduct) {
        setIsShowProduct(true)
        setIsLoading(false)
      } else {
        const productInventory = []
        selected.forEach(data => {
          productInventory.push({
            ProductID: data.key,
            ProductQuantity: parseInt(data.quantity),
            SupplyPrice: parseFloat(data.supplyPrice)
          })
        })
        if (selected.length <= 0) {
          message.warn('Please select products')
          setIsLoading(false)
          return
        }

        returnProduct = {
          SupplierID:
            values.DeliverTo != undefined ? values.DeliverTo.toString() : '',
          SupplierInvoiceNumber: values.SupplierInvoiceNumber
            ? values.SupplierInvoiceNumber
            : '',
          SourceOutletID:
            values.ReturnFrom != undefined ? values.ReturnFrom : '',
          DestinationOutletID: '',
          DeliveryDate: values.DeliveryDue
            ? values.DeliveryDue.format()
            : moment().format(),
          OrderNumber: '',
          ReturnNumber: values.ReturnNumber ? values.ReturnNumber : '',
          ReferenceName: values.NameRef ? values.NameRef : '',
          Notes: '',
          StockType: parseInt(StockOrderTypesEnum.ReturnStock),
          StockOrderProducts: productInventory
        }
        postStockOrderService(
          returnProduct,
          BEHAVIOUR_TYPE.POST,
          PkgFeatures.InventoryManagement
        )
      }
    } catch (ex) {
      setIsLoading(false)
    }
  }

  const onFinishFailed = errorInfo => {
    message.error('Kindly Attend to Missing Input')
  }

  const handleReturnFromChange = e => {
    let body = {
      OutletID: e,
      PurchaseOrderType: PurchaseOrderType.SupplierReturnNumber
    }
    const getOrderNumObj = ds.getOrderNumberGenerate(body, BEHAVIOUR_TYPE.POST)
    getOrderNumObj
      .then(response => {
        if (response) {
          if (response != '0') {
            form.setFieldsValue({ ReturnNumber: response.toString() })
          }
        }
      })
      .catch(e => {})
  }

  return (
    <>
      {!getIsDisableCreate && isFeatureAllowed ? (
        <div className='Content-wrapper NewStockReturn-pg'>
          <div className='back-arrow-h1'>
            <h1 className='d-flex align-items-center'>
              <ArrowLeftOutlined
                style={{ marginRight: 16 }}
                className='dk-vertical-align'
                onClick={() =>
                  history.push(
                    '/Dashboard/inventory/stockcontrol/stockcontrollist'
                  )
                }
              />
              <Breadcrumb separator='>'>
                <Breadcrumb.Item>
                  <IntlMessages id='discount.inventory' />
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  className='custom-stock-hoverbreadcrumb'
                  onClick={() =>
                    history.push('/Dashboard/inventory/stockcontrol')
                  }
                >
                  <IntlMessages id='stock.edit.stockcont' />
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <IntlMessages id='stock.edit.stockreturn' />
                </Breadcrumb.Item>
              </Breadcrumb>
            </h1>
          </div>
          <Spin
            tip={<IntlMessages id='sell.cashlisting.cashloading' />}
            spinning={getIsLoading}
            size='large'
          >
            <div className='mt-4'>
              <h1>
                <IntlMessages id='stock.retstock.new' />
              </h1>

              <Card
                className='gx-card Filters-wrapper No-BoxShadow'
                title={<IntlMessages id='stock.add.detail' />}
              >
                <Form
                  form={form}
                  name='ReturnStockForm'
                  className='ant-advanced-search-form Filters-Form'
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  scrollToFirstError
                >
                  <Row>{formFields()}</Row>
                  {!isShowProduct && (
                    <Form.Item>
                      <div className='display-margin-unset'>
                        <Row>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <Button
                              className='dk-btn-cancel'
                              type='primary'
                              size='large'
                              onClick={() => {
                                history.push(
                                  '/Dashboard/inventory/stockcontrol/stockcontrollist'
                                )
                              }}
                            >
                              <IntlMessages id='products.promoadd.canbtn' />
                            </Button>

                            <Button
                              className='dk-btn-add'
                              type='primary'
                              htmlType='submit'
                              size='large'
                            >
                              <IntlMessages id='stock.add.savebtn' />
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Form.Item>
                  )}
                </Form>
              </Card>

              {isShowProduct && (
                <div className='products-card'>
                  <Card
                    className=''
                    title={
                      <IntlMessages id='stock.retstock.importstockreturn' />
                    }
                  >
                    <GeneralProductImport isDraggerActive={false} />
                  </Card>
                  <Card
                    className='gx-card No-BoxShadow card-padd-0'
                    title={<IntlMessages id='products.addpricebook.products' />}
                  >
                    <div className='ProductSearch-StockReturn div-flow'>
                      <ProductSearch isLabel={false} />
                    </div>

                    <Row>
                      <Col
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: '20px' }}
                      >
                        <Table
                          className='gx-table-responsive'
                          columns={columns}
                          dataSource={selected}
                          rowClassName={() => 'editable-row'}
                          pagination={false}
                          footer={false}
                        ></Table>
                      </Col>
                    </Row>

                    <Row justify={'end'} className='total-div mt-3'>
                      <Col
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        className='text-right'
                      >
                        <h2>
                          <IntlMessages id='stock.add.total' />: {getCurrSymbol}
                          {`${
                            grandTotal
                              ? formatDigits(
                                  grandTotal,
                                  getDefaultDecimalPlaces
                                )
                              : '0.00'
                          }`}
                        </h2>
                      </Col>
                    </Row>

                    <div style={{ marginTop: 22 }}>
                      <Form
                        form={form}
                        name='ReturnStockForm'
                        className='ant-advanced-search-form'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <Row justify='end' gutter={18}>
                          <Col>
                            <Button
                              className='dk-btn-cancel'
                              type='primary'
                              onClick={() => {
                                history.push(
                                  '/Dashboard/inventory/stockcontrol/stockcontrollist'
                                )
                              }}
                              size='large'
                            >
                              <IntlMessages id='products.promoadd.canbtn' />
                            </Button>
                          </Col>
                          <Col>
                            <Button
                              className='dk-btn-add'
                              type='primary'
                              block
                              htmlType='submit'
                              size='large'
                            >
                              <IntlMessages id='stock.add.savebtn' />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </Card>
                </div>
              )}
            </div>
          </Spin>
        </div>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}

export default ReturnStock
